export const appName = 'control-center';
